import { render, staticRenderFns } from "./NotificationField.vue?vue&type=template&id=486a2260&scoped=true"
import script from "./NotificationField.vue?vue&type=script&lang=js"
export * from "./NotificationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a2260",
  null
  
)

export default component.exports